import { getPhoneCodeByTimezone } from 'timezone-phone-codes';
import ct from 'countries-and-timezones';

const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

// Fallback to Russia when the country cannot be resolved from the timezone
const DEFAULT_DIAL_CODE = '+7';
const DEFAULT_COUNTRY_CODE = 'RU';

export const getActiveDialCode = () => {
  return getPhoneCodeByTimezone(getTimezone()) || DEFAULT_DIAL_CODE;
};

export const getActiveCountryCode = () => {
  const country = ct.getCountryForTimezone(getTimezone()) || {};
  return country.id || DEFAULT_COUNTRY_CODE;
};
